import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { useAuth } from "./hooks/useAuth";
import ConfigPage from "./pages/Config";
import Login from "./pages/Login";
import TabDetail from "./pages/TabDetail";

const App = () => {
  const { user } = useAuth();
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<ProtectedRoute isAllowed={!!user} />}>
          <Route path="/config" element={<ConfigPage />} />
          <Route path="/tab/:tab" element={<TabDetail />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
